import './styles/variables.css';
import './styles/sections.css';
import './styles/admin.css';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { AppRouter } from './routes/AppRouter';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
